import '../date.extensions';
export class PayslipCollection {

    payslips = [];
    payslipsWithoutDuplicates = [];
    consecutivePayslips = [];
    payslipsInError = [];
    notSavedPayslips = [];

    startDatePeriod: Date;
    endDatePeriod: Date;
    monthsLengthPeriod: number;
    startRetainedDate: Date;
    endRetainedDate: Date;

    numberOfUploadedPayslips = 0;

    constructor(payslipCollection) {
        this.payslips = payslipCollection;
    }

    setStartDatePeriod(date: Date) {
        this.startDatePeriod = date;
        this.startDatePeriod.setHours(0,0,0,0);
    }

    setEndDatePeriod(date: Date) {
        this.endDatePeriod = date;
        this.startDatePeriod.setHours(0,0,0,0);
    }

    setPayslips(payslips: Array<any>, deletable = true) {
        this.resetAllDownloadedFiles();
        this.payslips = [];
        payslips.forEach((payslip) => {
            if (payslip.typepage === "P" || payslip.typepage === "S") {
                this.addPayslip(payslip);
            }
        });

        if (!deletable) {
            this.setOlderPayslipsAsNotDeletable();
        }
        
        this.setLongestConsecutivePayslips();
    }

    getConsecutivePayslips() {
        return this.consecutivePayslips;
    }

    addPayslips([...payslipsData]) {
        payslipsData.forEach(data => {
            this.addPayslip(data);
        });
    }

    addPayslip(payslipData) {
        if (payslipData["bsprincipal"]) {
            this.addSecondaryPayslip(payslipData);
        } else if (payslipData["datedebutbs"]) {
            this.addNewPayslip(payslipData);
        } else {
            this.addErrorPayslip(payslipData);
        }
    }

    private addSecondaryPayslip(payslipData) {
        this.payslips.map(payslip => {
            if (payslip.data && 
                payslipData["bsprincipal"] === payslip.data["id"]) 
            {
                let ids = [];
                payslip.otherPages.forEach(secondaryPayslip => {
                    ids.push(secondaryPayslip["id"]); 
                });
                if (!ids.includes(payslipData["id"])) {
                    if (payslip.data.url == payslipData.url ||
                        payslip.data.url == payslipData.urlfront ||
                        payslip.data.urlfront == payslipData.urlfront) 
                    {
                        payslip.otherPages.push([]);
                    } else {
                        payslip.otherPages.push(payslipData);
                    }
                }
            }
        })
    }

    private addNewPayslip(payslipData) {
        let yearAndMonth = this.getYearAndMonth(new Date(payslipData["datedebutbs"]));
        let isAdded = false;

        this.payslips.map((payslip, index) => {
            if (!isAdded) {
                isAdded = this.tryToAddPayslipInCurrentPeriod(payslip, payslipData, index, yearAndMonth, isAdded);
            }
        })
        if (!isAdded) {
            let error = null;
            let isValid = true;
            if (payslipData["typepage"] !== "P") {
                error = "1ère page manquante";
                isValid = false;
            }
            this.payslips.push(this.createPayslip(yearAndMonth, payslipData, error, isValid, false));
            this.numberOfUploadedPayslips++;
        }

        this.orderByYearAndMonthASC();
    }

    private tryToAddPayslipInCurrentPeriod(payslip, payslipData, index, yearAndMonth, isAdded) {
        let error = null;
        let isValid = true;
        if (payslipData["typepage"] !== "P") {
            error = "1ère page manquante";
            isValid = false;
        }
        if (payslip.data && (payslip.yearAndMonth === yearAndMonth)) {
            // Cas du doublon (qui possède la même période)
            if (payslip.isLoading) {
                this.payslips.splice(index, 1, 
                    this.createPayslip(yearAndMonth, payslipData, error, isValid, false));
            } else {
                this.payslips.splice(index + 1, 0, 
                    this.createPayslip(yearAndMonth, payslipData, error, isValid, true));
            }
            isAdded = true;
            this.numberOfUploadedPayslips ++;
        } else if (payslip.yearAndMonth === yearAndMonth) {
            payslip.data = payslipData;
            payslip.isValid = isValid;
            payslip.error = error;
            payslip.isLoading = false;
            isAdded = true;
            this.numberOfUploadedPayslips ++;
        }
        return isAdded;
    }

    private addErrorPayslip(payslipData) {
        this.payslipsInError.push(this.createPayslip(null, payslipData, payslipData.erreur, false));
    }

    addNotSavedPayslip(payslipData) {
        this.notSavedPayslips.push(this.createPayslip(null, payslipData, payslipData.erreur, false));
    }

    addLoadingPayslip(data) {
        let payslip = this.createPayslip(null, data, null, false);
        payslip.isLoading = true;
        this.payslips.unshift(payslip);
    }

    setLongestConsecutivePayslips() {
        this.prepareToAnalyzePayslips();
        let longestConsecutivePayslips = this.getLongestConsecutivePayslips();
        if (longestConsecutivePayslips.length === 1
            && longestConsecutivePayslips[0].length > 2)
        {
            this.payslips.map((payslip, index) => {
                if (longestConsecutivePayslips[0].includes(payslip)
                    && !payslip.isDuplicate) 
                {
                    if (this.consecutivePayslips.length === this.monthsLengthPeriod) {
                        this.consecutivePayslips[0].isConsecutive = false;
                        this.consecutivePayslips.splice(0, 1);
                    }
                    this.consecutivePayslips.push(this.payslips[index]);
                    payslip.isConsecutive = true;
                } else {
                    payslip.isConsecutive = false;
                }
            })
            this.setDuplicatesAsConsecutives(this.consecutivePayslips);
            this.setRetainedPeriod();
        } else {
            this.resetConsecutivesPayslips();
        }
    }

    prepareToAnalyzePayslips() {
        this.deleteLoadingPeriods();
        this.removeEmptyPayslips();
        this.fillBlanksBetweenPayslips();
        this.resetConsecutivesPayslips();
        this.setPayslipsCopyWithoutDuplicates();
        this.checkPayslipsAreConsecutive();
    }

    removeEmptyPayslips() {
        this.payslips = this.payslips.filter(payslip => {
            if (payslip.data) {
                return payslip;
            }
        })
    }

    resetConsecutivesPayslips() {
        this.startRetainedDate = null;
        this.consecutivePayslips = [];
        this.payslips.map((payslip) => {
            payslip.isConsecutive = false;
        })
    }
    
    setPayslipsCopyWithoutDuplicates() {
        this.payslipsWithoutDuplicates = [];
        let array = Array.from(this.payslips);
        array.map(payslip => {
            if (!payslip.isDuplicate) {
                this.payslipsWithoutDuplicates.push(payslip)
            }
        })
    }

    checkPayslipsAreConsecutive() {
        this.payslipsWithoutDuplicates.map((payslip, index) => {
            if (payslip.data) {
                let nextPayslip = this.payslipsWithoutDuplicates[index + 1];
                // if (this.isPayslipInPeriod(payslip) 
                //     && nextPayslip && nextPayslip.data 
                //     && this.isPayslipInPeriod(nextPayslip)) 
                if (nextPayslip && nextPayslip.data && nextPayslip.isValid) 
                {
                    if (this.isNextPayslipConsecutive(payslip, nextPayslip)) {
                        payslip.isConsecutive = true;
                        nextPayslip.isConsecutive = true;
                    }
                }
            }
        })
    }

    /**
     * @returns array - car il peut y avoir plusieurs périodes consécutives de la même longueur
     */
    getLongestConsecutivePayslips() {
        let resultArray = [];
        let consecutivePayslipsArray = this.getAllConsecutivePayslips();
        let max = 0;

        consecutivePayslipsArray.map((array, index) => {
            let length = array.length;
            if (length === max) {
                resultArray.push(consecutivePayslipsArray[index]);
            } else if (length > max) {
                resultArray = [];
                max = length;
                resultArray.push(consecutivePayslipsArray[index]);
            }   
        })

        return resultArray;
    }

    getAllConsecutivePayslips() {
        let resultArray = [];
        
        this.payslipsWithoutDuplicates.map((payslip, index) => {
            if (payslip.isConsecutive) {
                let streakIsGoing = true;
                let i = 1;
                let payslipArray = [];
                payslipArray.push(payslip);
                resultArray.push(payslipArray);
                do {
                    let nextPayslip = this.payslipsWithoutDuplicates[index + i];
                    if (nextPayslip && nextPayslip.isConsecutive) {
                        payslipArray.push(nextPayslip);
                    } else {
                        streakIsGoing = false;
                    }
                    i ++;
                } while (streakIsGoing);
            }
        })
        
        return resultArray;
    }

    setDuplicatesAsConsecutives(payslips) {
        payslips.map(payslip => {
            this.payslips.map(p => {
                if (payslip.yearAndMonth === p.yearAndMonth)
                    p.isConsecutive = true;
            })
        })
    }
    
    setRetainedPeriod() {
        let length = this.consecutivePayslips.length;
        if (length) {
            this.startRetainedDate = 
                this.getDateFromYearAndMonth(this.consecutivePayslips[0].yearAndMonth);
            this.endRetainedDate = 
                this.getDateFromYearAndMonth(this.consecutivePayslips[length - 1].yearAndMonth);
        }
    }

    isPayslipInPeriod(payslip) {
        let startDate = new Date(payslip.data["datedebutbs"]);
        if (startDate && this.startDatePeriod && this.endDatePeriod) {
            startDate.setHours(0,0,0,0);

            if (startDate.getTime() >= this.startDatePeriod.getTime()
            && startDate.getTime() <= this.endDatePeriod.getTime()) {
                return true;
            }
        }
        return false;
    }

    isNextPayslipConsecutive(payslip, nextPayslip) {
        if (!payslip.data || !nextPayslip.data){
            return false;
        }
        let differenceMonths = 
            new Date(payslip.data["datedebutbs"])
                .getDifferenceInMonths(new Date(nextPayslip.data["datedebutbs"]));
        return differenceMonths === 1;
    }

    fillBlanksBetweenPayslips() {
        let periodBlanks = this.getPeriodBlanks();
        this.fillPeriodBlanks(periodBlanks);
    }
    
    getPeriodBlanks() {
        let periodBlanks = [];
        this.payslips.map((payslip, index) => {
            let nextPayslip = this.payslips[index + 1];
            if (nextPayslip && nextPayslip.data &&
                !this.isNextPayslipConsecutive(payslip, nextPayslip)) 
            {
                let date = new Date(payslip.data["datedebutbs"]);
                let nextDate = new Date(nextPayslip.data["datedebutbs"]);
                let difference = date.getDifferenceInMonths(nextDate);
                let monthsToAdd = difference;
                let yearsToAdd = 0;

                if (difference > 12) {
                    monthsToAdd = (difference % 12) - 1;
                    yearsToAdd = Math.floor(Math.abs(difference / 12));
                } else if (monthsToAdd > 0) {
                    monthsToAdd--;
                }
                periodBlanks.push({ 
                    payslip : payslip,
                    nextPayslip : nextPayslip,
                    startDate : date,
                    endDate : nextDate,
                    monthsToAdd : monthsToAdd,
                    yearsToAdd : yearsToAdd,
                });
            }
        })
        return periodBlanks;
    }

    fillPeriodBlanks(periodBlanks: Array<any>) {
        periodBlanks.map((period) => {
            if (period.yearsToAdd > 0) {
                let months = period.yearsToAdd * 12;
                let startDate = period.startDate;
                for (let i = 1; i <= months; i++) {
                    startDate.setMonth(startDate.getMonth() + 1);
                    let yearAndMonth = this.getYearAndMonth(startDate);
                    let index = this.getIndexFromPayslip(period.payslip);
                    this.payslips.splice(index + i, 0,
                        this.createPayslip(yearAndMonth, null, null, false, false)
                    );
                }
            } 
            if (period.monthsToAdd > 0) {
                let endDate = period.endDate;
                for (let i = 0; i < period.monthsToAdd; i++) {
                    endDate.setMonth(endDate.getMonth() - 1);
                    let yearAndMonth = this.getYearAndMonth(endDate);
                    let index = this.getIndexFromPayslip(period.nextPayslip);
                    this.payslips.splice(index - i, 0,
                        this.createPayslip(yearAndMonth, null, null, false, false)
                    );
                }
            } else if (period.monthsToAdd === -1) {
                let index = this.getIndexFromPayslip(period.nextPayslip);
                this.payslips.splice(index - 1, 1);
            }
        })
    }
    
    resetAllDownloadedFiles() {
        this.numberOfUploadedPayslips = 0;
        this.payslipsInError = [];
        this.payslips = [];
    }

    removePayslip(payslipRemoved) {
        this.payslips.map((payslip, index) => {
            if (payslip === payslipRemoved) {
                this.payslips.splice(index, 1);
                if (!payslip.isDuplicate) {
                    let duplicates = this.getDuplicatesFromPayslip(payslip);
                    if (duplicates.length) {
                        duplicates[0].isDuplicate = false;
                    }
                }
                if (this.payslips[index + 1]) {
                    this.payslips[index + 1].isConsecutive = false;
                }
                this.numberOfUploadedPayslips --;
                this.setLongestConsecutivePayslips();
            }
        })
    }

    removeErrorPayslip(payslipRemoved) {
        this.payslipsInError.map((payslip, index) => {
            if (payslip === payslipRemoved) {
                this.payslipsInError.splice(index, 1);
            }
        })
    }

    removeNotSavedPayslip(payslipRemoved) {
        this.notSavedPayslips.map((payslip, index) => {
            if (payslip === payslipRemoved) {
                this.notSavedPayslips.splice(index, 1);
            }
        })
    }

    getDuplicatesFromPayslip(payslip) {
        return this.payslips.filter(p => {
            if (p.yearAndMonth == payslip.yearAndMonth) {
                return p;
            }
        })
    }

    getIndexFromPayslip(currentPayslip) {
        let resultIndex;
        this.payslips.map((payslip, index) => {
            if (currentPayslip == payslip) {
                resultIndex = index;
            }
        })
        return resultIndex;
    }

    getDateFromYearAndMonth(yearAndMonth: number) {
        let year = parseInt(yearAndMonth.toString().substring(0, 4));
        let month = parseInt(yearAndMonth.toString().substring(4, 6));
        return new Date(year, month);
    }

    orderByYearAndMonthASC() {
        this.payslips.sort((a,b) => a.yearAndMonth - b.yearAndMonth);
    }

    getYearAndMonth(date: Date) {
        let month = ("0" + date.getMonth()).slice(-2);
        let year = date.getFullYear();
        return parseInt(year + month);
    }

    hasAtLeastOneUploadedPayslip() {
        if (this.payslips.length > 0 || this.payslipsInError.length > 0) {
            return true
        }
        return false;
    }

    setOlderPayslipsAsNotDeletable() {
        this.payslips.forEach(payslip => {
            if (!payslip.data["new"]) {
                payslip.isDeletable = false;
            }
        });
    }

    deleteLoadingPeriods() {
        this.payslips = this.payslips.filter(payslip => {
            if (payslip.isLoading !== true) {
                return payslip;
            }
        })
    }

    createPayslip(yearAndMonth: number, data: object, error: string, isValid: boolean, 
        isDuplicate = false) {
        return {
            yearAndMonth : yearAndMonth,
            data : data,
            error : error,
            isValid : isValid,
            isDuplicate : isDuplicate,
            isConsecutive : false,
            isLoading : false,
            isDeletable : true,
            otherPages : [],
        }
    }
}
